<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
                <div class="divisor32"></div>
                <div>
                    <!-- Datos generales -->
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <inputCustom [titulo]="'Clave'"
                                [(ngModel)]="entidad.clave"
                                [disabled]="true"></inputCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <dropdownCustom [titulo]="'Competencia*'"
                                [(ngModel)]="entidad.competenciaid"
                                [buscar]="true" [opciones]="SelCompetencia"
                                displayValor="nombre" valorName="competenciaid"
                                propiedad="competenciaid"
                                [errorActivo]="errorActivo"
                                [disabled]="ver"
                                (ngModelChange)="SetCriterio($event)"></dropdownCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <dropdownCustom [titulo]="'Critero*'"
                                [(ngModel)]="entidad.criterioid"
                                [disabled]="ver"
                                [errorActivo]="errorActivo"
                                [buscar]="true" [opciones]="SelCriterio"
                                displayValor="nombre" valorName="criterioid"></dropdownCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <dropdownCustom [titulo]="'Tipo de pregunta*'"
                                [(ngModel)]="entidad.tipopreguntaid"
                                [disabled]="ver"
                                [errorActivo]="errorActivo"
                                [buscar]="false" [opciones]="SelTipoPregunta"
                                (ngModelChange)="SetEscalaEvaluacion($event)"
                                displayValor="nombre" valorName="tipopreguntaid"
                                propiedad="tipopreguntaid"></dropdownCustom>
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <dropdownCustom [titulo]="'Escala de evaluación*'" *ngIf="visible"
                                [(ngModel)]="entidad.escalaevaluacionid"
                                [buscar]="false"
                                [errorActivo]="errorActivo"
                                [disabled]="ver"
                                (ngModelChange)="SetEscalaEvaluacionValor($event)"
                                [opciones]="SelEscalaevaluacion"
                                displayValor="nombre"
                                valorName="escalaevaluacionid"
                                propiedad="escalaevaluacionid"></dropdownCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <dropdownCustom [titulo]="'Nivel'"
                                [(ngModel)]="entidad.nivelid"
                                [disabled]="ver"
                                [multiSelect]="true" [buscar]="false"
                                [opciones]="SelNivel" displayValor="nombre"
                                valor="[]" valorName="nivelid"
                                propiedad="nivelid"></dropdownCustom>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-12 col-12">
                            <checkBoxCustom [titulo]="'Activo'" [alineacion]="1"
                                [disabled]="ver"
                                [(ngModel)]="entidad.activo"></checkBoxCustom>
                        </div>
                    </div>
                    <div class="row">
                      <div class="col-6">
                      </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12" style="text-align: right;">
                            <checkBoxCustom [titulo]="'Mostrar en autoevaluación'" [alineacion]="1" [disabled]="ver"
                                [(ngModel)]="entidad.mostrarautoevaluacion" (ngModelChange)="cargartexto($event)"></checkBoxCustom>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <textareaCustom [titulo]="'Pregunta*'"
                                [(ngModel)]="entidad.pregunta"
                                [disabled]="ver"
                                [errorActivo]="errorActivo"></textareaCustom>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12" *ngIf="entidad.mostrarautoevaluacion">
                            <textareaCustom [titulo]="'Pregunta autoevaluación (Opcional)'" [disabled]="ver" [errorActivo]="errorActivo"
                                [(ngModel)]="entidad.autoevaluacion"></textareaCustom>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <checkBoxCustom [titulo]="'Relacionado a otras preguntas'"
                                [alineacion]="1"
                                [disabled]="ver"
                                [(ngModel)]="entidad.relacionado"
                                (ngModelChange)="TablaRelacionadas(entidad.relacionado)"></checkBoxCustom>
                        </div>
                    </div>
                    <ng-container *ngIf="abierto">
                        <div *ngFor="let item of SelEscalaevaluacionvalor; index as i">

                            <h5>Escala de evaluación <strong>{{item.escalaevaluacionid.nombre}}</strong> - Respuesta <strong>{{item.nombre}}</strong></h5>

                            <div class="row margen">
                                <div class="col-12">
                                    <div class="panelBotonesFiltro mixto">
                                        <button matTooltip="Asignar Pregunta"
                                                class="btn boton botonXS" [disabled]="ver"
                                                (click)="Formulario(item.escalaevaluacionvalorid)">
                                            <span> {{'Asignar preguntas relacionadas'}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- datos -->
                            <div >
                                <dx-data-grid
                                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                    (onContentReady)="onContentReady($event)"
                                    id="tabla"
                                    [columnAutoWidth]="true"
                                    [noDataText]="'Sin Datos'"
                                    [dataSource]="filtrarinfo(item.escalaevaluacionvalorid)"
                                    [showColumnHeaders]="true"                                    >
                                    <dxo-paging
                                        [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                    <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                                    <dxo-pager
                                        [visible]="false"
                                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                        [displayMode]="sistemaService.tablaPaginacionModo"
                                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                        [showInfo]="sistemaService.tablaPaginacionInfo"
                                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                    </dxo-pager>
                                    <dxi-column
                                        [allowExporting]="false"
                                        caption="Acciones"
                                        cellTemplate="cellAcciones"
                                        alignment="center">

                                    </dxi-column>
                                    <dxi-column
                                        dataField="competencia"
                                        caption="Competencia">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="criterio"
                                        caption="Criterio">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="pregunta"
                                        caption="Pregunta">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="tipopregunta"
                                        caption="Tipo de pregunta">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="nivel"
                                        caption="Nivel">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="clave"
                                        caption="Clave">
                                    </dxi-column>

                                    <!-- Activo -->

                                    <!-- Acciones -->
                                    <div  *dxTemplate="let cell of 'cellAcciones'">
                                        <a matTooltip="Eliminar" class="tablaBoton separado delete"
                                       (click)="Eliminar(cell.data, item.escalaevaluacionvalorid)"
                                       *ngIf="sistemaService.permisos.eliminar && !ver">
                                       <i class="fa fa-trash fa-lg"
                                           aria-hidden="true"></i>
                                        </a>

                                    </div>

                                </dx-data-grid>
                            </div>
                        </div>
                        <div *ngIf="abiertopreguntaabierta">

                            <h5>Escala de evaluación <strong>Abierta</strong> - Respuesta <strong>Abierta</strong></h5>

                            <div class="row margen">
                                <div class="col-12">
                                    <div class="panelBotonesFiltro mixto">
                                        <button matTooltip="Asignar Pregunta"
                                                class="btn boton botonXS" [disabled]="ver"
                                                (click)="Formularioabierta()">
                                            <span> {{'ASIGNAR PREGUNTASRELACIONADAS'}}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- datos -->
                            <div >
                                <dx-data-grid
                                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                    id="tabla"
                                    [columnAutoWidth]="true"
                                    [noDataText]="'Sin Datos'"
                                    [dataSource]="listpreguntaabierta"
                                    [showColumnHeaders]="true">
                                    <dxo-paging
                                        [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                                    <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                                    <dxo-pager
                                        [visible]="true"
                                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                        [displayMode]="sistemaService.tablaPaginacionModo"
                                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                        [showInfo]="sistemaService.tablaPaginacionInfo"
                                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                                    </dxo-pager>
                                    <dxi-column
                                        [allowExporting]="false"
                                        caption="Acciones"
                                        cellTemplate="cellAcciones"
                                        alignment="center">

                                    </dxi-column>
                                    <dxi-column
                                        dataField="competencia"
                                        caption="Competencia">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="criterio"
                                        caption="Criterio">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="pregunta"
                                        caption="Pregunta">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="tipopregunta"
                                        caption="Tipo de pregunta">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="tipocolaborador"
                                        caption="Tipo de colaborador">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="departamento"
                                        caption="Departamento">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="nivel"
                                        caption="Nivel">
                                    </dxi-column>
                                    <dxi-column
                                        dataField="clave"
                                        alignment="left"
                                        caption="Clave">
                                    </dxi-column>

                                    <!-- Activo -->

                                    <!-- Acciones -->
                                    <div  *dxTemplate="let cell of 'cellAcciones'">
                                        <a matTooltip="Eliminar" class="tablaBoton separado delete"
                                       (click)="Eliminar(cell.data)"
                                       *ngIf="sistemaService.permisos.eliminar && !ver">
                                            <i class="fa fa-trash fa-lg"
                                               aria-hidden="true"></i>
                                        </a>

                                    </div>

                                </dx-data-grid>
                            </div>
                        </div>

                    </ng-container>
                </div>
                <div class="divisor20"></div>
                <div class="row margen">
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                                    (click)="Salir()">
                                <span> {{'Cancelar'}}</span>
                            </button>
                            <div *ngIf="accion.accionid != 2">
                                <div class="divisorH16 "></div>
                                <button matTooltip="Guardar" class="boton botonSM filled"
                                        (click)="Guardar()" [disabled]="ver"
                                        *ngIf="sistemaService.permisos.agregar">
                                    <span> {{'Guardar'}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<relacionPregunta #relacionpregunta (respuesta)="GuardarPreguntaRelacion($event)"></relacionPregunta>
